/* ============================================================
   "Completa tu look" en linea (arriba del boton de compra).

   Cada prenda vive en un {% form 'product' %} nativo. El tema ya
   escucha el submit de esos formularios y lo manda por su propio
   ajax de carrito, asi que el alta y el drawer salen por el camino
   de siempre. Aqui solo se resuelve que variante corresponde a la
   talla y color elegidos.

   Si por lo que sea el tema no intercepta el submit, el formulario
   se envia de forma nativa y el producto igual entra al carrito.
   ============================================================ */

(function () {
  'use strict';

  function variantesDe(form) {
    var nodo = form.querySelector('[data-cmb-variants]');
    if (!nodo) {
      return [];
    }
    try {
      return JSON.parse(nodo.textContent) || [];
    } catch (e) {
      return [];
    }
  }

  function seleccionado(form, tipo) {
    var btn = form.querySelector('[data-cmb-opt="' + tipo + '"].is-on');
    return btn ? btn.getAttribute('data-value') : null;
  }

  function grupoExiste(form, tipo) {
    return !!form.querySelector('[data-cmb-opts="' + tipo + '"]');
  }

  function textos(form) {
    var boton = form.querySelector('[data-cmb-add-text]');
    return {
      nodo: boton,
      pedir: boton ? boton.getAttribute('data-pick') || boton.textContent.trim() : ''
    };
  }

  function resolver(form) {
    var idInput = form.querySelector('[data-cmb-id]');
    var boton = form.querySelector('[data-cmb-add]');
    var etiqueta = form.querySelector('[data-cmb-add-text]');
    if (!idInput || !boton) {
      return;
    }

    var talla = grupoExiste(form, 'talla') ? seleccionado(form, 'talla') : '';
    var color = grupoExiste(form, 'color') ? seleccionado(form, 'color') : '';

    var faltaTalla = grupoExiste(form, 'talla') && !talla;
    var faltaColor = grupoExiste(form, 'color') && !color;

    if (faltaTalla || faltaColor) {
      idInput.value = '';
      boton.disabled = true;
      if (etiqueta) {
        etiqueta.textContent = etiqueta.getAttribute('data-pick') || etiqueta.textContent;
      }
      return;
    }

    var match = variantesDe(form).filter(function (v) {
      var t = grupoExiste(form, 'talla') ? v.talla === talla : true;
      var c = grupoExiste(form, 'color') ? v.color === color : true;
      return t && c && v.ok;
    })[0];

    if (match) {
      idInput.value = match.id;
      boton.disabled = false;
      if (etiqueta) {
        etiqueta.textContent = etiqueta.getAttribute('data-add') || etiqueta.textContent;
      }
    } else {
      /* Esa combinacion existe como opcion pero no hay pieza. */
      idInput.value = '';
      boton.disabled = true;
      if (etiqueta) {
        etiqueta.textContent = etiqueta.getAttribute('data-none') || etiqueta.textContent;
      }
    }
  }

  /* Deja disponibles solo las tallas que existen en el color elegido
     (y al reves). Evita ofrecer combinaciones sin stock. */
  function depurarOpciones(form) {
    var variantes = variantesDe(form);
    ['talla', 'color'].forEach(function (tipo) {
      var otro = tipo === 'talla' ? 'color' : 'talla';
      if (!grupoExiste(form, otro)) {
        return;
      }
      var elegidoOtro = seleccionado(form, otro);
      if (!elegidoOtro) {
        return;
      }
      Array.prototype.forEach.call(
        form.querySelectorAll('[data-cmb-opt="' + tipo + '"]'),
        function (btn) {
          var valor = btn.getAttribute('data-value');
          var hay = variantes.some(function (v) {
            return v.ok && v[tipo] === valor && v[otro] === elegidoOtro;
          });
          btn.classList.toggle('is-off', !hay);
        }
      );
    });
  }

  function init(scope) {
    var forms = (scope || document).querySelectorAll('[data-cmb-form]');
    Array.prototype.forEach.call(forms, function (form) {
      if (form.getAttribute('data-cmb-listo') === '1') {
        return;
      }
      form.setAttribute('data-cmb-listo', '1');

      /* Si solo hay una opcion posible, se elige sola: un clic menos. */
      ['talla', 'color'].forEach(function (tipo) {
        var botones = form.querySelectorAll('[data-cmb-opt="' + tipo + '"]');
        if (botones.length === 1) {
          botones[0].classList.add('is-on');
        }
      });

      form.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-cmb-opt]');
        if (!btn || btn.classList.contains('is-off')) {
          return;
        }
        var tipo = btn.getAttribute('data-cmb-opt');
        Array.prototype.forEach.call(
          form.querySelectorAll('[data-cmb-opt="' + tipo + '"]'),
          function (o) { o.classList.remove('is-on'); }
        );
        btn.classList.add('is-on');
        depurarOpciones(form);
        resolver(form);
      });

      form.addEventListener('submit', function () {
        /* No se hace preventDefault: el tema toma el submit y lo manda
           por su ajax. Solo se marca el estado de carga. */
        var boton = form.querySelector('[data-cmb-add]');
        if (boton) {
          boton.classList.add('btn--loading');
          window.setTimeout(function () {
            boton.classList.remove('btn--loading');
          }, 2500);
        }
      });

      depurarOpciones(form);
      resolver(form);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
